import request from '@/utils/request'

let UserApi = {

    /*用户登录*/
    login(data, errorback) {
        return request._post('/shop/passport/login', data, errorback);
    },
    /*退出登录*/
    loginOut(data, errorback) {
        return request._post('/shop/passport/logout', data, errorback);
    },
    /*添加用户*/
    adduser(data, errorback) {
        return request._post('/shop/user.user/add', data, errorback);
    },

    /*修改用户*/
    edituser(data, errorback) {
        return request._post('/shop/user.user/edit', data, errorback);
    },
     /*修改代理老板*/
     editAgent(data, errorback) {
        return request._post('/shop/user.user/editAgent', data, errorback);
    },
    /*充值*/
    userRecharge(data, errorback) {
        return request._post('/shop/user.user/recharge', data, errorback);
    },
    /*删除用户*/
    deleteuser(data, errorback) {
        return request._post('/shop/user.user/delete', data, errorback);
    },

    /*用户列表*/
    userlist(data, errorback) {
        return request._post('/shop/user.user/index', data, errorback);
    },
    /*等级列表*/
    gradelist(data, errorback) {
        return request._post('/shop/user.grade/index', data, errorback);
    },
    /*添加等级*/
    addgrade(data, errorback) {
        return request._post('/shop/user.grade/add', data, errorback);
    },
    /*修改等级*/
    editGrade(data, errorback) {
        return request._post('/shop/user.grade/edit', data, errorback);
    },
    /*删除等级*/
    deletegrade(data, errorback) {
        return request._post('/shop/user.grade/delete', data, errorback);
    },
    /*会员升级记录*/
    gradeLog(data, errorback) {
        return request._get('/shop/user.grade/log', data, errorback);
    },
    /*用户余额*/
    BalanceLog(data, errorback) {
        return request._post('/shop/user.Balance/log', data, errorback);
    },
    /*充值记录*/
    RechargeOrder(data, errorback) {
        return request._post('/shop/user.Recharge/order', data, errorback);
    },
    /*修改密码*/
    EditPass(data, errorback) {
        return request._post('/shop/passport/editPass', data, errorback);
    },
    /*用户等级*/
    structureGrade(data, errorback) {
        return request._post('/shop/user.Structure/grade', data, errorback);
    },
    /*用户结构*/
    structureList(data, errorback) {
        return request._post('/shop/user.Structure/user', data, errorback);
    },
    /*佣金记录*/
    AgentLog(data, errorback) {
        return request._post('/shop/user.agent_log/index', data, errorback);
    },
     /* 积分区域记录*/
     RegionLog(data, errorback) {
        return request._post('/shop/user.agent_log/regionlog', data, errorback);
    },
    /*佣金记录*/
    AgentCapital(data, errorback) {
        return request._post('/shop/user.agent_log/agentCapital', data, errorback);
    },
    /*代理老板*/
    agentboss(data, errorback) {
        return request._post('/shop/user.agent/boss', data, errorback);
    },
    // 平台管理
    plantformList(data,errorback){
        return request._get('/shop/user.plantform/index',data,errorback);
    },
    plantformAdd(data,errorback){
        return request._post('/shop/user.plantform/add',data,errorback);
    },
    plantformEdit(data,errorback){
        return request._post('/shop/user.plantform/edit',data,errorback);
    },
    plantformDel(data,errorback){
        return request._post('/shop/user.plantform/delete',data,errorback);
    },
    //爱好管理
    hobbyList(data,errorback){
        return request._get('/shop/user.hobby/index',data,errorback);
    },
    hobbyAdd(data,errorback){
        return request._post('/shop/user.hobby/add',data,errorback);
    },
    hobbyEdit(data,errorback){
        return request._post('/shop/user.hobby/edit',data,errorback);
    },
    hobbyDel(data,errorback){
        return request._post('/shop/user.hobby/delete',data,errorback);
    },
    //职业管理
    jobList(data,errorback){
        return request._get('/shop/user.job/index',data,errorback);
    },
    jobAdd(data,errorback){
        return request._post('/shop/user.job/add',data,errorback);
    },
    jobEdit(data,errorback){
        return request._post('/shop/user.job/edit',data,errorback);
    },
    jobDel(data,errorback){
        return request._post('/shop/user.job/delete',data,errorback);
    },
    // 用户标签管理
    labelList(data,errorback){
        return request._get('/shop/user.label/index',data,errorback);
    },
    labelAdd(data,errorback){
        return request._post('/shop/user.label/add',data,errorback);
    },
    labelEdit(data,errorback){
        return request._post('/shop/user.label/edit',data,errorback);
    },
    labelDel(data,errorback){
        return request._post('/shop/user.label/delete',data,errorback);
    },
    // 用户备注管理
    remarkList(data,errorback){
        return request._get('/shop/user.remark/index',data,errorback);
    },
    remarkAdd(data,errorback){
        return request._post('/shop/user.remark/add',data,errorback);
    },
    remarkEdit(data,errorback){
        return request._post('/shop/user.remark/edit',data,errorback);
    },
    remarkDel(data,errorback){
        return request._post('/shop/user.remark/delete',data,errorback);
    },
    /*获取基础设置*/
    getSettingData(data, errorback) {
        return request._get('/shop/user.Setting/index', data, errorback);
    },
    /*保存基础设置*/
    saveSettingData(data, errorback) {
        return request._post('/shop/user.Setting/index', data, errorback);
    },
}

export default UserApi;



// WEBPACK FOOTER //
// ./src/api/user.js